module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAABCAYAAAAFKSQHAAAAAXNSR0IArs4c6QAAAA5JREFUCB1j/A8EDCQCAMmgA/69KEN+AAAAAElFTkSuQmCC"